<template>
  <v-container
    class="employees-card"
    :class="{
      'ma-0': noSpacing,
      'full-height': fullHeight,
      mini
    }"
  >
    <v-row
      v-for="(emp, i) in employees"
      :key="i"
      class="pa-0 ma-0 employee-row"
    >
      <v-col cols="12" class="pa-0 ma-0 employee-col">
        <span class="name">
          {{ ` • ${emp?.name} (${getCatNames(emp?.categories)})` }}
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  props: {
    value: {
      type: Array,
      required: true
    },
    noSpacing: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    employees () {
      let value = this.value || [],
          employees = this.get_data.employees || []
      return value.map(emp => {
        return employees.find(emp_ => emp_.id === emp)
      })
    }
  },
  methods: {
    getStatus (status) {
      return (this.get_global.defaults.options.users.status && typeof this.get_global.defaults.options.users.status[status] !== 'undefined' ? this.get_global.defaults.options.users.status[status] : {})
    },
    getCatNames (cats) {
      if (cats == null) return;

      let names = cats.map(e => e.name) || []
      return (names.length > 0 ? names.join(' / ') : this.lang.categories.new.all_cat)
    }
  }
}
</script>

<style lang="scss">
.employees-card {
  #app & {
    width: 100%;
    width: auto;
    height: auto;
    max-height: 40px;
    margin: 4px 0px;
    padding: 3.5px;
    border-radius: 3px;
    font-size: 12px;
    overflow: hidden;
    position: relative;
    transition: all 0.3s ease-in-out;
    display:block;
    z-index: 1 !important;
    max-width: 155px !important;
    &.mini {
      max-width: 75px !important;
    }
    &.full-height {
      max-height: 100% !important;
    }
    span {
      display: block;
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      pointer-events: none !important;
    }
    .categories {
      font-size: 11px;
      visibility: hidden;
    }
    &:hover{
      display: inline-block !important;
      position: absolute !important;
      max-width: 270px !important;
      max-height: 250px !important;
      z-index: 999 !important;
      .categories{
        visibility: visible !important;
      }
    }
  }
  #app.theme--light & {
    background: rgba(25, 118, 210, 0.1) !important;
    &:hover {
      background: rgba(25, 118, 210, 0.85) !important;
      color: #fff !important;
    }
  }
  #app.theme--dark & {
    background: linear-gradient(325deg,
      rgba(0,0,0,0.07) 0%,
      rgba(0,0,0,0.2) 30%,
      rgba(0,0,0,0.2) 50%,
      rgba(0,0,0,0.2) 70%,
      rgba(0,0,0,0.07) 100%
    );
    &:hover {
      background: rgba(0,0,0,0.15) !important;
    }
  }
}
</style>
